import { render, staticRenderFns } from "./Program_Edit.vue?vue&type=template&id=61aab2b0&"
import script from "./Program_Edit.vue?vue&type=script&lang=js&"
export * from "./Program_Edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports